import { FC, ReactNode } from 'react';

interface PlanStepCardProps {
  children: ReactNode;
}

export const PlanStepCard: FC<PlanStepCardProps> = ({ children }) => (
  <div className="mx-auto w-full max-w-2xl overflow-hidden rounded-2xl border border-(--neutral-black-NB200) bg-(--neutral-white-NW1000)">
    <div className="h-1.5 w-full bg-(--primary-O900)" />
    <div className="flex flex-col gap-6 p-5 sm:p-8">{children}</div>
  </div>
);
